import { BillingTierFeature } from "types/generated";
import { SubscriptionContext } from "views/Account/SubscriptionWrapper";

import useTypedContext from "../../../hooks/useTypedContext";

const useTierFeature = (tierFeature?: BillingTierFeature) => {
  const { tierFeatures } = useTypedContext(SubscriptionContext);

  if (!tierFeature) return false;

  return tierFeatures.includes(tierFeature);
};

export default useTierFeature;
